import React, { ReactNode } from 'react';

import {
  CmCheckBox,
  CmTable,
  CmTableHeader,
  CmTbody,
  CmTh,
} from '@/components/uiParts';

export type ThProps = {
  minWidth: string;
  label: string;
  position?: 'left' | 'center' | 'right';
};

type Props = {
  isMultipleCheck?: boolean;
  isSelectAll?: boolean;
  ths: ThProps[];
  handleMultipleCheck?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  children: ReactNode;
};

export const CmBaseTable: React.FC<Props> = ({
  isMultipleCheck = false,
  isSelectAll = false,
  ths,
  handleMultipleCheck,
  children,
}) => {
  return (
    <CmTable>
      <CmTableHeader>
        {isMultipleCheck && (
          <CmTh left="0" zIndex="2">
            <CmCheckBox
              isChecked={isSelectAll}
              size="lg"
              onChange={handleMultipleCheck}
            />
          </CmTh>
        )}
        {ths.map((th) => (
          <CmTh
            {...(th.position !== undefined ? { textAlign: th.position } : {})}
            key={th.label}
            minWidth={th.minWidth}
          >
            {th.label}
          </CmTh>
        ))}
      </CmTableHeader>
      <CmTbody>{children}</CmTbody>
    </CmTable>
  );
};
